import omit from 'lodash/omit';
import moment from 'moment';
import { apiSlice } from '../../app/services/apiSlice';
import { excludeScopedTimelineEntries } from '../../utils/timelineFilter';

const APPLICATION_URL = 'applications/';

export const kanbanApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getApplicationOverview: builder.mutation({
      query: (params) => ({
        url: `${APPLICATION_URL}${params.applicationId}`,
        params: { ...params },
      }),
    }),
    getApplicationRecentJobs: builder.mutation({
      query: (params) => ({
        url: `${APPLICATION_URL}${params.applicationId}/jobs`,
        params: { ...params },
      }),
    }),

    uploadFile: builder.mutation({
      query: (data) => ({
        url: `${APPLICATION_URL}${data?.applicationId}/documents`,
        method: 'POST',
        body: { ...data },
      }),
    }),
    getApplicationCommunication: builder.mutation({
      query: (params) => ({
        url: `${APPLICATION_URL}messages`,
        params: { ...params },
      }),
    }),

    getNotes: builder.mutation({
      query: (params) => ({
        url: `${params.prefix}/notes?${params.getId}`,
        params: params.payLoad.params,
      }),
    }),

    addNote: builder.mutation({
      query: (data) => ({
        url: `${data.prefix}/notes`,
        method: 'POST',
        body:
          data.prefix === 'jobs'
            ? omit(data, 'prefix')
            : omit(data, 'noteAttachments'),
      }),
    }),
    deleteNote: builder.mutation({
      query: (params) => ({
        url: `${params.prefix}/notes/${params.getId}`,
        method: 'DELETE',
      }),
    }),
    deleteFile: builder.mutation({
      query: (data) => ({
        url: `${data.type}${data.appId}/document/${data.docId}`,
        method: 'DELETE',
      }),
    }),
    updateNote: builder.mutation({
      query: (params) => ({
        url: `${params.prefix}/notes`,
        method: 'PUT',
        body: omit(params, 'prefix'),
      }),
    }),
    preSignedNoteUrl: builder.mutation({
      query: (params) => ({
        url: `${params.prefix}/notes/preSignedNoteAttachment`,
        method: 'POST',
        body: omit(params, 'prefix'),
      }),
    }),

    getAllInterviewSlots: builder.query({
      query: (id) => ({
        url: `${APPLICATION_URL}${id}/slots`,
      }),
      transformResponse: (responseData) => {
        responseData.interviews = responseData?.appInterview?.filter((slot) =>
          moment
            ?.utc(slot?.maxDate ? slot?.maxDate : slot?.minDate)
            ?.add(slot?.duration, 'minutes')
            ?.local()
            ?.isAfter(new Date()),
        );
        responseData.pastinterviews = responseData?.appInterview?.filter(
          (slot) =>
            moment
              ?.utc(slot?.maxDate ? slot?.maxDate : slot?.minDate)
              ?.add(slot?.duration, 'minutes')
              ?.local()
              ?.isBefore(new Date()),
        );
        return responseData || {};
      },
    }),
    updateInterviewStatus: builder.mutation({
      query: (params) => ({
        url: `${APPLICATION_URL}${params.id}/slots/${params.appSlotId}/${params.status}`,
        method: 'PUT',
      }),
    }),
    addMeetingNote: builder.mutation({
      query: (params) => ({
        url: `${APPLICATION_URL}/slots`,
        method: 'POST',
        body: params,
      }),
    }),
    getAllSlotsAgainstApp: builder.query({
      query: (id) => ({
        url: `${APPLICATION_URL}${id}/slots`,
      }),
    }),
    deleteApplication: builder.mutation({
      query: (data) => ({
        url: `${APPLICATION_URL}${data.appId}`,
        method: 'DELETE',
        params: { jobId: data?.jobId },
      }),
    }),
    getSingleHiringPlan: builder.query({
      query: (id) => ({
        // url: `${FORM_URL}questionnaire-forms/${id}`,
        url: `hiring-plans/${id?.id}`,
      }),
    }),

    getHiringPlanDetails: builder.query({
      query: (params) => ({
        // url: `${FORM_URL}questionnaire-forms/${id}`,
        url: `hiring-plans/${params?.id}`,
        params
      }),
    }),
    
    getActivity: builder.mutation({
      query: (params) => ({
        url: `timeline`,
        method: 'GET',
        params,
      }),
      transformResponse: (response) => ({
        ...response,
        timelineData: excludeScopedTimelineEntries(response?.timelineData),
      }),
    }),

    getDashboardActivity: builder.mutation({
      query: (params) => ({
        url: `dashboard-timeline`,
        method: 'GET',
        params,
      }),
      transformResponse: (response) => ({
        ...response,
        timelineData: excludeScopedTimelineEntries(response?.timelineData),
      }),
    }),

    getJobActivity: builder.mutation({
      query: (params) => ({
        url: `timeline/jobs`,
        method: 'GET',
        params,
      }),
    }),

    getAllHiringPlanListing: builder.mutation({
      query: (params) => ({
        url: `hiring-plans`,
        params: {
          ...params,
          dropDownList:true
        },
      }),
      
      transformResponse: (responseData) => {
        responseData.options = responseData?.hiringPlans?.map((hr) => ({
          ...hr,
          value: hr.id,
          label: hr,
          title: moment(hr.startDate).format('Do MMM YYYY'),
        }));
        return responseData || {};
      },
    }),

    getAllCampaigns: builder.query({
      query: (params) => {
        const { jobId,jhpId, ...rest } = params;
        return {
          url: `/jobs/${jobId}/${jhpId}/campaigns`,
          method: 'GET',
          params: rest,
        };
      },
    }),
    getAllHiringListing: builder.query({
      query: (params) => ({
        url: `hiring-plans`,
        params,
      }),
    }),
    

    // getJobHiringPlanAllLocations: builder.query({
    //   query: (params) => ({
    //     url: `/hiring-plans/locations`,
    //     params,
    //   }),
    //   transformResponse: (responseData) => {
    //     responseData =[{label:'All Locations'}, ...responseData?.hiringPlanLocations?.map((pos) => ({
    //       ...pos,
    //       label: `${pos?.centralLocation?.postalTown ?? ''}${pos?.centralLocation?.postalCode ? `, ${pos?.centralLocation?.postalCode}` : ''}`,
    //     }))]
    //     return responseData || {};
    //   },
    // }),
    getHiringListing: builder.mutation({
      query: (params) => ({
        method: 'GET',
        url: `hiring-plans`,
        params,
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.hiringPlans?.map((pos) => ({
          ...pos,
          title: `${moment(pos?.startDate).format('D MMM YYYY')}${pos?.endDate?' - ' + moment(pos?.endDate).format('D MMM YYYY'):''}`,
          value: pos?.id,
        }));
        return responseData || {};
      },
    }),
    closeJobCampaign: builder.mutation({
      query: (data) => ({
        url: `/jobs/${data.jobId}/campaigns/${data.campaignId}/closed`,
        method: 'POST',
      }),
      invalidatesTags: (_result, _error, data) => [
        { type: 'Campaign', id: data?.campaignId },
      ],
    }),
    submitHiringRequirement: builder.mutation({
      query: (params) => ({
        url: `hiring-plans`,
        method: 'POST',
        body: params,
      }),
    }),
    requalify: builder.mutation({
      query: (params) => ({
        url: `${APPLICATION_URL}status/${params?.statusId}`,
        method: 'PUT',
        body: omit(params, 'statusId'),
      }),
    }),

    addMeetingNotes: builder.mutation({
      query: (params) => ({
        url: `interviews/${params?.interviewId}`,
        method: 'PUT',
        body: params
      }),
    }),

    getInterviewModalSlots: builder.query({
      query: (param) => ({
        url: `${APPLICATION_URL}${param?.appId}/slots/${param?.interviewId}`,
        method: 'GET',
      }),
    }),
    getApplicationHiringDetails: builder.query({
      query: (params) => ({
        url: `hiring-plans/app/${params?.appId}`
      }),
    }),

    updateHiringTeam: builder.mutation({
      query: (params) => ({
        url: `hiring-plans`,
        method: 'PUT',
        body: params
      }),
    }),

    extendHiringPlan: builder.mutation({
      query: (params) => ({
        url: `hiring-plans/extend-request`,
        method: 'POST',
        body: params
      }),
    }),
    extensionReqHiringPlan: builder.mutation({
      query: (params) => ({
        url: `hiring-plans/extend-request/${params?.id}`,
        method: 'PUT',
        body: params
      }),
    }),

    getApplicationAiScore: builder.query({
      query: (applicationId) => ({
        url: `${APPLICATION_URL}${applicationId}/ai-score`,
      }),
      providesTags: (result, error, applicationId) => [
        { type: 'ApplicationAiScore', id: applicationId },
      ],
    }),

    refreshApplicationAiScore: builder.mutation({
      query: (applicationId) => ({
        url: `${APPLICATION_URL}${applicationId}/ai-score/refresh`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, applicationId) => [
        { type: 'ApplicationAiScore', id: applicationId },
      ],
    }),
  }),
});

export const {
  useGetDashboardActivityMutation,
  useGetJobActivityMutation,
  useExtensionReqHiringPlanMutation,
  useExtendHiringPlanMutation,
  useGetAllHiringPlanListingMutation,
  useGetApplicationOverviewMutation,
  useGetHiringListingMutation,
  useGetApplicationRecentJobsMutation,
  useUploadFileMutation,
  useGetAllHiringListingQuery,
  useAddNoteMutation,
  useGetApplicationCommunicationMutation,
  useGetNotesMutation,
  useGetSingleHiringPlanQuery,
  usePreSignedNoteUrlMutation,
  useSubmitHiringRequirementMutation,
  useUpdateNoteMutation,
  useDeleteNoteMutation,
  useDeleteFileMutation,
  useGetAllInterviewSlotsQuery,
  useUpdateInterviewStatusMutation,
  useAddMeetingNoteMutation,
  useGetAllSlotsAgainstAppQuery,
  useDeleteApplicationMutation,
  useGetActivityMutation,
  useGetAllCampaignsQuery,
  useCloseJobCampaignMutation,
  useRequalifyMutation,
  useAddMeetingNotesMutation,
  // useGetJobHiringPlanAllLocationsQuery,
  useGetInterviewModalSlotsQuery,
  useGetApplicationHiringDetailsQuery,
  useUpdateHiringTeamMutation,
  useGetHiringPlanDetailsQuery,
  useGetApplicationAiScoreQuery,
  useRefreshApplicationAiScoreMutation,
} = kanbanApiSlice;